<template>
  <ConfirmationDialog
    :showHazardIcon="dialogState.showHazardIcon"
    :headerMsg="dialogState.headerMsg"
    :visible="dialogState.isVisible"
    :message="dialogState.message"
    :onConfirm="handleConfirm"
    :onCancel="handleCancel"
    @update:visible="updateVisibility"
  />
</template>

<script setup>
  import { watch } from "vue";
  import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
  import { usePromiseDialog } from "@/composables/usePromiseDialog";

  const emit = defineEmits(["update:visible", "confirm", "cancel"]);

  const {
    dialogState,
    isRevealed,
    handleConfirm: confirmHandler,
    handleCancel: cancelHandler,
    reveal
  } = usePromiseDialog();

  // Watch for changes in dialogState.isVisible to emit update:visible
  watch(
    () => dialogState.value.isVisible,
    (newVal) => {
      emit("update:visible", newVal);
    }
  );

  const handleConfirm = async () => {
    await confirmHandler();
    emit("confirm");
  };

  const handleCancel = () => {
    cancelHandler();
    emit("cancel");
  };

  const updateVisibility = (value) => {
    dialogState.value.isVisible = value;
    emit("update:visible", value);
  };
</script>
